import type { SVGProps } from "react";
export interface Glasses01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Glasses01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Glasses01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 16c0-1.197.28-3.02.61-4.781.335-1.791.743-3.62 1.035-4.874a4.07 4.07 0 0 1 2.687-2.932l1.437-.48a1.126 1.126 0 0 1 .711 2.135l-1.437.479c-.61.203-1.064.7-1.207 1.31-.288 1.239-.688 3.03-1.015 4.776-.332 1.775-.571 3.406-.571 4.367a1.125 1.125 0 0 1-2.25 0m20 0c0-.961-.24-2.592-.572-4.367a98 98 0 0 0-.521-2.578l-.494-2.199a1.82 1.82 0 0 0-1.206-1.31l-1.438-.478-.107-.043a1.126 1.126 0 0 1 .708-2.124l.111.031 1.437.48.248.091a4.07 4.07 0 0 1 2.439 2.842l.5 2.236c.181.837.367 1.742.535 2.638.33 1.762.61 3.584.61 4.781a1.125 1.125 0 0 1-2.25 0M9.42 15.035a4.96 4.96 0 0 1 4.853-.169l.305.169.095.064a1.125 1.125 0 0 1-1.151 1.92l-.102-.054-.17-.095a2.71 2.71 0 0 0-2.673.095 1.125 1.125 0 0 1-1.157-1.93"
      />
      <path
        fill={color}
        d="M8.875 16a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m12 0a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m-9.75 0a5.124 5.124 0 1 1-10.25 0 5.125 5.125 0 0 1 10.25 0m12 0a5.125 5.125 0 1 1-10.25 0 5.125 5.125 0 0 1 10.25 0"
      />
    </svg>
  );
}
